/* eslint-disable no-unused-vars */
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const Box = styled.div`
  margin-bottom: 32px;
`;
